import React from 'react';
import cliente from 'assets/img/2026/ELBB/cliente.png';
import inovacao from 'assets/img/2026/ELBB/inovacao.png';
import asg from 'assets/img/2026/ELBB/asg.png';
import investimentos from 'assets/img/2026/ELBB/investimentos.png';
import cultura from 'assets/img/2026/ELBB/cultura.png';
import todos from 'assets/img/2026/todos.png';
import './HeroIniciativasElbb.scss';

interface HeroIniciativasElbbProps {
  categoriaSelecionada: string;
  onCategoriaChange: (categoria: string) => void;
  title?: string;
  subtitle?: React.ReactNode;
}

export const HeroIniciativasElbb: React.FC<HeroIniciativasElbbProps> = ({
  categoriaSelecionada,
  onCategoriaChange,
  title,
  subtitle,
}) => {
  const categorias = [
    { id: 'clientes', nome: 'Clientes', imagem: cliente },
    { id: 'financeira', nome: 'Financeira', imagem: investimentos },
    { id: 'asg', nome: 'ASG', imagem: asg },
    { id: 'transformacao_digital_processos', nome: 'Transformação digital e processos', imagem: inovacao },
    { id: 'pessoas_cultura', nome: 'Cultura e Pessoas', imagem: cultura },
    { id: 'todos', nome: 'Todos', imagem: todos }
  ];

  return (
    <div className="hero-iniciativas-elbb" role="banner">
      <div className="hero-iniciativas-elbb__content">
        <h1 className="hero-iniciativas-elbb__title" tabIndex={0}>
          {title ?? 'Iniciativas do Prêmio ELBB 2026'}
        </h1>
        <p className="hero-iniciativas-elbb__subtitle" tabIndex={0}>
          {subtitle ?? <>Explore, elogie e favorite as iniciativas <br /> que estão transformando o BB</>}
        </p>

        <div className="hero-iniciativas-elbb__categorias">
          <label className="hero-iniciativas-elbb__label" tabIndex={0}>Selecione o tema:</label>
          <div className="hero-iniciativas-elbb__categorias-grid" role="radiogroup" aria-label="Temas das iniciativas">
            {categorias.map((categoria) => (
              <button
                key={categoria.id}
                className={`hero-iniciativas-elbb__categoria-btn ${
                  categoriaSelecionada === categoria.id ? 'active' : ''
                }`}
                onClick={() => onCategoriaChange(categoria.id)}
                role="radio"
                aria-checked={categoriaSelecionada === categoria.id}
                aria-label={`Filtrar por ${categoria.nome}`}
              >
                <img src={categoria.imagem} alt="" aria-hidden="true" />
                <span className="hero-iniciativas-elbb__categoria-nome">{categoria.nome}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
